import { useMemo } from 'react';
import { useQuery, QueriesOptions } from 'react-query';
import PropertyService from '../../services/propertyService';
import useAbortController from '../useAbortController';

const usePropertyConfigQuery = ({
  organizationId,
  propertyId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  options: QueriesOptions,
}) => {
  const propertyService = useMemo(() => new PropertyService(), []);
  const abortControllerOptions = useAbortController();
  const queryKey = [
    'propertyService.getPropertyConfigs',
    organizationId,
    propertyId,
  ];

  return useQuery(
    queryKey,
    () =>
      propertyService.getPropertyConfigs(
        organizationId,
        propertyId,
        abortControllerOptions,
      ),
    {
      refetchOnWindowFocus: false,
      enabled: !!organizationId && !!propertyId,
      ...options,
    },
  );
};

export default usePropertyConfigQuery;
